// Режим бокового меню.
//
// Меню нужно по-разному в зависимости от того, чем занят оператор. Пока он
// ходит по разделам, удобно держать его раскрытым; когда работает в широкой
// таблице — каждый лишний пиксель ширины на счету, и меню должно уйти в
// полосу значков. Раскрытие полосы при наведении не должно двигать страницу:
// таблица уезжает вправо ровно в тот момент, когда оператор ведёт мышь к
// нужной строке.
//
// Выбор хранится в браузере: это настройка рабочего места, а не сессии.

const STORAGE_KEY = 'sts-nav-mode'

// overlay — полоса значков, раскрывается поверх страницы
// pinned  — раскрыто и закреплено, рабочая область сдвинута
// hidden  — скрыто совсем
export const NAV_MODES = ['overlay', 'pinned', 'hidden']

const DEFAULT_MODE = 'overlay'

export function preferredNavMode () {
  const saved = localStorage.getItem(STORAGE_KEY)

  return NAV_MODES.includes(saved) ? saved : DEFAULT_MODE
}

export function saveNavMode (mode) {
  const value = NAV_MODES.includes(mode) ? mode : DEFAULT_MODE
  localStorage.setItem(STORAGE_KEY, value)

  return value
}

// Кнопка одна, поэтому режимы идут по кругу — в порядке от самого частого.
export function nextNavMode (mode) {
  const index = NAV_MODES.indexOf(mode)

  return NAV_MODES[(index + 1) % NAV_MODES.length]
}

export const NAV_MODE_LABELS = {
  overlay: 'Меню: полоса значков',
  pinned: 'Меню: закреплено',
  hidden: 'Меню: скрыто'
}

export const NAV_MODE_ICONS = {
  overlay: 'mdi-menu',
  pinned: 'mdi-dock-left',
  hidden: 'mdi-backburger'
}
